import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import VisionaryLeadership from "./sections/VisionaryLeadership";
import TheDesignManifesto from "./sections/TheDesignManifesto";
import SignatureArtistry from "./sections/SignatureArtistry";
import OurVisualLegacy from "./sections/OurVisualLegacy";
import TheClipCraftCommunity from "./sections/TheClipCraftCommunity";
import ConnectTheDots from "./sections/ConnectTheDots";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <VisionaryLeadership />
      <TheDesignManifesto />
      <SignatureArtistry />
      <OurVisualLegacy />
      <TheClipCraftCommunity />
      <ConnectTheDots />
      <Footer />
    </div>;
}